import apiClient from "../../axios/apiClient";

export const getIncomeList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INCOMELIST_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Income`,
        {
          params: {
            limit: limit,
            page: page,
            search: search,
            sort: sort,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INCOMELIST_FULFILLED",
        payload: response.data?.data,
        count: response.data?.count,
        permissions: response.data?.permissions,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INCOMELIST_REJECTED",
        payload: error.response,
      });
    }
  };


  export const saveIncomeData = (token, data) => async (dispatch) => {
    try {
      console.log('token, data', token, data);
      dispatch({ type: "ADD_INCOME_PENDING" });
  
      const response = await apiClient.post(
        `/api/admin/v1/Add-Income`,
        data, // Data payload should be the second argument
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({ type: "ADD_INCOME_FULFILLED", payload: response.data });
    } catch (error) {
      //console.log(error.response.data);
      dispatch({ type: "ADD_INCOME_REJECTED", payload: error.response });
    }
  };
  

  export const getIncomeListById =(token,id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_INCOMELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/admin/v1/Income/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //console.log('response.data?.data',response.data?.data);
      dispatch({
        type: "GET_INCOMELISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      console.log(error);
      dispatch({
        type: "GET_INCOMELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateIncomeData = (token, data, id) => async (dispatch) => {
  try {
    console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INCOME_PENDING" });

    const response = await apiClient.post(
      `/api/admin/v1/Update-Income/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INCOME_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INCOME_REJECTED", payload: error.response });
  }
};


export const updateIncomeStatusData = (token, id, status) => async (dispatch) => {
  try {
    //console.log('token, data', token, data);
    dispatch({ type: "UPDATE_INCOME_STATUS_PENDING" });
    const data={
      "status":status
    }
    const response = await apiClient.post(
      `/api/admin/v1/Update-Income-Status/${id}`, // Endpoint URL with vehicle ID
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_INCOME_STATUS_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_INCOME_STATUS_REJECTED", payload: error.response });
  }
};


export const deleteIncomeData = (token, id) => async (dispatch) => {
  try {
    console.log('token, id', token, id);
    dispatch({ type: "DELETE_INCOME_PENDING" });

    const response = await apiClient.delete(
      `/api/admin/v1/Delete-Income/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_INCOME_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_INCOME_REJECTED", payload: error.response });
  }
};